/**
 * GraphQL clients (Apollo, AppSync, etc.) may reject with a plain object
 * `{ data, errors }` instead of an `Error`. Sentry cannot use those as real
 * exceptions; normalize to a string message for reporting and beforeSend hooks.
 */
export function getGraphQLStyleErrorMessage(err: unknown): string | null {
	if (!err || typeof err !== 'object' || !('errors' in err)) {
		return null;
	}

	const gqlErrors = (err as { errors?: unknown }).errors;
	if (!Array.isArray(gqlErrors)) {
		return null;
	}
	if (gqlErrors.length > 0) {
		const first = gqlErrors[0] as { message?: string };
		return first?.message ?? 'GraphQL error occurred';
	}
	return 'GraphQL error occurred';
}
